import React from 'react';
import { useTranslation } from '../../../redux/TranslationHelper';

/**
 * 결제 성공 컴포넌트의 속성 패널 인터페이스
 */
interface PaymentSuccessPropertiesProps {
  properties: Record<string, any>;
  onPropertiesChange: (props: Record<string, any>) => void;
}

/**
 * 결제 성공 컴포넌트의 속성 패널
 * 에디터에서 컴포넌트 속성을 편집할 수 있게 해주는 양식
 */
const PaymentSuccessProperties: React.FC<PaymentSuccessPropertiesProps> = ({ 
  properties, 
  onPropertiesChange 
}) => {
  const { t } = useTranslation();
  const { componentProps = {} } = properties;
  
  // 기본값 설정
  const {
    title = t("결제가 완료되었습니다"),
    successMessage = t("결제가 성공적으로 처리되었습니다."),
    orderHistoryButtonText = t("주문 내역 확인"),
    continueShoppingButtonText = t("쇼핑 계속하기"),
    showOrderDetails = true,
    redirectToHome = "/",
    redirectToOrderHistory = "/mypage/orderlist",
    loadingText = t("결제 정보를 처리 중입니다..."),
    waitingMessage = t("잠시만 기다려주세요.")
  } = componentProps;

  // 속성 변경 핸들러
  const handlePropertyChange = (key: string, value: any): void => {
    const updatedProps = {
      ...properties,
      componentProps: {
        ...componentProps,
        [key]: value
      }
    };
    onPropertiesChange(updatedProps);
  };

  return (
    <div className="property-panel-form">
      <div className="form-group">
        <label>{t("타이틀")}</label>
        <input
          type="text"
          className="form-control"
          value={title}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePropertyChange('title', e.target.value)}
          placeholder={t("결제가 완료되었습니다")}
        />
      </div>
      
      <div className="form-group">
        <label>{t("성공 메시지")}</label>
        <input
          type="text"
          className="form-control"
          value={successMessage}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePropertyChange('successMessage', e.target.value)}
          placeholder={t("결제가 성공적으로 처리되었습니다.")}
        />
      </div>
      
      <div className="form-group">
        <label>
          <input
            type="checkbox"
            checked={showOrderDetails}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePropertyChange('showOrderDetails', e.target.checked)}
          />
          {t("주문 상세 표시")}
        </label>
      </div>
      
      <div className="form-group">
        <label>{t("주문 내역 버튼 텍스트")}</label>
        <input
          type="text"
          className="form-control"
          value={orderHistoryButtonText}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePropertyChange('orderHistoryButtonText', e.target.value)}
          placeholder={t("주문 내역 확인")}
        />
      </div>
      
      <div className="form-group">
        <label>{t("쇼핑 계속하기 버튼 텍스트")}</label>
        <input
          type="text"
          className="form-control"
          value={continueShoppingButtonText}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePropertyChange('continueShoppingButtonText', e.target.value)}
          placeholder={t("쇼핑 계속하기")}
        />
      </div>
      
      <div className="form-group">
        <label>{t("홈 경로")}</label>
        <input
          type="text"
          className="form-control"
          value={redirectToHome}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePropertyChange('redirectToHome', e.target.value)}
          placeholder="/"
        />
      </div>
      
      <div className="form-group">
        <label>{t("주문 내역 경로")}</label>
        <input
          type="text"
          className="form-control"
          value={redirectToOrderHistory}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePropertyChange('redirectToOrderHistory', e.target.value)}
          placeholder="/mypage/orderlist"
        />
      </div>
      
      <div className="form-group">
        <label>{t("로딩 텍스트")}</label>
        <input
          type="text"
          className="form-control"
          value={loadingText}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePropertyChange('loadingText', e.target.value)}
          placeholder={t("결제 정보를 처리 중입니다...")}
        />
      </div>
      
      <div className="form-group">
        <label>{t("대기 메시지")}</label>
        <input
          type="text"
          className="form-control"
          value={waitingMessage}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePropertyChange('waitingMessage', e.target.value)}
          placeholder={t("잠시만 기다려주세요.")}
        />
      </div>
    </div>
  );
};

export default PaymentSuccessProperties; 